export type { AutocompleteProps } from './Autocomplete.types'
export { default as Autocomplete } from './Autocomplete'